import { createFileRoute } from "@tanstack/react-router";
import { listProductOptions, listProductSubscriptions } from "api-client";
import { z } from "zod";

import { PRODUCT_SUBSCRIPTIONS_PAGE_SIZE } from "src/helpers/productPaymentsPageQuery";
import { loaderHandler } from "src/lib/loaderHandler";
import { CoachProductsSubscriptionsPage } from "src/pages/CoachProductsSubscriptionsPage";

const routeSearchSchema = z.object({
  tab: z.enum(["active", "inactive"]).optional(),
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
  products: z.array(z.string()).optional(),
});

export const Route = createFileRoute(
  "/_auth/_coach/products/_tabs/subscriptions",
)({
  component: CoachProductsSubscriptionsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async () => {
      const [subscriptions, products] = await Promise.all([
        listProductSubscriptions({
          query: {
            tab: deps.tab,
            q: deps.q,
            productIds: deps.products,
            pageIndex: deps.p ?? 0,
            pageSize: deps.ps ?? PRODUCT_SUBSCRIPTIONS_PAGE_SIZE,
          },
        }).then((res) => {
          return res.data.data;
        }),
        listProductOptions().then((res) => {
          return res.data.data;
        }),
      ]);

      return { data: { subscriptions, products } };
    });
  },
});
